module.exports = __webpack_public_path__ + "static/img/16.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/16.png
// module id = 6/M8
// module chunks = 0